import { Component } from '@angular/core';

@Component({
  selector: 'app-ai-assistance',
  templateUrl: './ai-assistance.component.html',
  styleUrls: ['./ai-assistance.component.scss']
})
export class AiAssistanceComponent {
  messages = [
    {
      from: 'bot',
      text: 'Hi, you can ask me anything about LTTS Policies here!',
      tags: ['HR Policy', 'Medical Policy', 'personal', 'Skills', 'Attendance', 'Leaves', 'Holidays', 'Assets', 'Projects']
    },
    {
      from: 'user',
      text: 'Hi, I\'m looking for a query on Attendance',
      tags: []
    },
    {
      from: 'bot',
      text: 'Alright! Let\'s have something related  with a quest for exploration.',
      tags: ['Regularize Missed Punches', 'My Attendance pending IS approval']
    }
  ];
  user = {
    name: 'E Rajeshwari',
    avatar: 'assets/icons/app-icon-1.png'
  };
}